<template>
  <div>
    <div v-show="isLoading" class="loader">
      <b-spinner class="align-middle mb-3"></b-spinner>
      <strong>Loading...</strong>
    </div>

    <div v-show="!isLoading">
      <!-- Success State -->
      <div v-if="!hasErrors" class="card p-4">
        <div class="success text-center">
          <img width="385" height="287" alt="upload success" :src="uploadSuccessImg" />
          <h5 class="mt-2 mb-3">Berhasil unggah</h5>
          <p>Pergi ke Menu Data Customer - Pelacak untuk melihat hasil unggahan</p>
        </div>
      </div>

      <!-- Error State -->
      <div v-else>
        <b-tabs v-model="activeTab" lazy>
          <b-tab title="Device Set To Customer" class="card p-4">
            <div class="mb-3 p-3 border-start border-primary border-4 bg-light"
              v-html="$t('qcdevice.import.failedNoteSetToCustomer')" />
            <Table :fields="deviceSetToCustomerFields" :listGetter="getErrorTableData" />
          </b-tab>
        </b-tabs>

        <!-- Debug info (hapus setelah production) -->
        <!-- <pre>{{ jobResult }}</pre> -->
      </div>
    </div>
  </div>
</template>

<script>
import uploadSuccessImg from '@/assets/images/import-device/upload-success.png'
import {
  deviceSetToCustomerFields,
  transformErrorDataToTableFormat,
} from '../lib/uploadResultFieldsSetToCustomer'
import Table from '../components/Table'
import * as importJobsApi from '@/services/rest-api-sms/lib/import-jobs/import-jobs'

export default {
  components: { Table },

  data() {
    return {
      activeTab: 0,
      deviceSetToCustomerFields,
      isLoading: true,
      jobResult: null,
      tableData: [],
    }
  },

  computed: {
    uploadSuccessImg() {
      return uploadSuccessImg
    },

    hasErrors() {
      return this.jobResult?.failed_rows > 0 || this.tableData.length > 0
    },
  },

  async mounted() {
    const jobId = this.$route.params.jobId

    if (!jobId) {
      this.$router.replace({ name: 'Device Import Set To Customer' })
      return
    }

    await this.fetchResult(jobId)
  },

  methods: {
    async getErrorTableData() {
      return this.tableData
    },

    async fetchResult(jobId) {
      try {
        const res = await importJobsApi.getJobDetail(jobId)

        this.jobResult = res.data

        // Transform error data from error_summary
        if (this.jobResult?.error_summary) {
          this.tableData = transformErrorDataToTableFormat(this.jobResult.error_summary)
        } else {
          this.tableData = []
        }

      } catch (error) {
        console.error('Fetch result error:', error)
        this.$toast.error('Gagal mengambil hasil import')
        this.$router.replace({ name: 'Device Import Set To Customer' })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.loader {
  min-height: min(50vh, 500px);
  display: grid;
  place-items: center;
  place-content: center;
  background-color: white;
}
</style>
